import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import Input from './input'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import createLinkToImmutable from '_/utils/createLinkToImmutable'
import { Map } from 'immutable'

/**
 * Bottom navigation component
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class FeedbackModal extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired
  }

  static contextTypes = {
    store: React.PropTypes.object,
    notify: React.PropTypes.func
  }

  constructor(props, context) {
    super(props, context)
    this.state = {
      active: false,
      feedback: Map({
        name: props.account.get('name'),
        email: props.account.get('email'),
        url: '',
        comments: '',
        captcha: false
      })
    }
  }

  showWindow () {
    this.setState({ active: true })
  }

  hideWindow () {
    this.setState({
      active: false,
      feedback: Map({
        name: this.props.account.get('name'),
        email: this.props.account.get('email'),
        comments: '',
        url: '',
        captcha: false
      })
    })
  }

  async sendFeedback (evt) {
    evt.preventDefault()
    const store = this.context.store
    const feedback = this.state.feedback.toJS()
    feedback.url = location.href
    try {
      await store.post('/sendFeedback', feedback)
      this.hideWindow()
      this.context.notify('Feedback sent')
    } catch (er) {
      this.setState({
        errors: er.response.body.details
      })
    }
  }

  render() {
    const ln = createLinkToImmutable(this, 'feedback')

    return (
      <Modal show={this.state.active} onHide={::this.hideWindow}>
        <Modal.Header closeButton>
          <h3 className="modal-title">REDIComps Feedback</h3>
        </Modal.Header>

        <Modal.Body>
          <p>Have a comment or a question? Let us know and we'll get back to you as soon as possible!</p>
          <Input
            autoFocus
            type="textarea"
            valueLink={ln('comments')}
            name="comments" />

          <Input
            label="Verify you aren't a robot by checking this box."
            type="switch"
            checkedLink={ln('captcha')}
            name="captcha" />
        </Modal.Body>

        <Modal.Footer>
          <Button
            type="submit"
            bsStyle="info"
            disabled={!this.state.feedback.get('comments') || !this.state.feedback.get('captcha')}
            onClick={::this.sendFeedback}>
            Send feedback
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default FeedbackModal



// WEBPACK FOOTER //
// ./modules/shared/components/feedbackModal.js